import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Users2, Download } from 'lucide-react';
import { API, cardCls, txtMain, txtSub } from './nlShared';
import { LoadingSpinner } from '../core';

export function NlSegments({ theme }) {
  const light = theme === 'light';
  const [segs, setSegs] = useState(null);

  useEffect(() => {
    axios.get(`${API}/admin/nl/segments`, { withCredentials: true }).then(r => setSegs(r.data)).catch(() => setSegs([]));
  }, []);

  if (!segs) return <LoadingSpinner />;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="nl-segments">
      {segs.map(s => (
        <div key={s.id} className={`${cardCls(light)} p-5`} data-testid={`nl-segment-${s.id}`}>
          <div className="flex items-start justify-between mb-2">
            <span className="w-8 h-8 rounded-lg bg-[#E9641A]/10 flex items-center justify-center"><Users2 size={15} className="text-[#E9641A]" /></span>
            <span className={`text-lg font-bold ${txtMain(light)}`}>{s.count.toLocaleString('fr-FR')}</span>
          </div>
          <p className={`text-sm font-bold ${txtMain(light)}`}>{s.label}</p>
          <p className={`text-xs mt-1 ${txtSub(light)}`}>{s.desc}</p>
        </div>
      ))}
    </div>
  );
}
